/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

import React from "react";
import {MATERIAL_REQUEST_CARD_MODEL} from "../../Model/Model";
import CustomCard from "../../../../../components/CustomCard";
import {getDateFormat} from "../../../../../Apis/functions";

const MaterialDispatchBadge = ({ t, showBadge, dispatchStatusId, dispatchReason, dispatchDate, dispatchUser }) => {

    return (
        <>
            { showBadge &&
            (() => {
                const data = MATERIAL_REQUEST_CARD_MODEL.getById(dispatchStatusId);
                return (
                    <CustomCard
                        classes={`border-radius-8px`}
                        classCard={`border-radius-8px ${data.classCard}`}
                        children={
                            <div className={`d-flex flex-column justify-content-start gap-3`}>
                                <div className={"gap-2"}>
                                    <p className={`ibl-font-w-600 fs-14px ${data?.fontColor}`}>
                                        {t(data?.title)}
                                    </p>
                                    {dispatchReason && (
                                        <p className={"fs-12px ibl-font-w-600 font-color-shades-800"}>
                                            {dispatchReason}
                                        </p>
                                    )}
                                </div>
                                <p className={"fs-12px font-color-shades-600"}>
                                    {t(data?.byTrans)} {dispatchUser} ·{" "}
                                    {dispatchDate !== null ? getDateFormat(dispatchDate) : ""}
                                </p>
                            </div>
                        }
                    />
                );
            })()
            }
        </>
    );
};

export default MaterialDispatchBadge;
